/* eslint no-unused-vars: 0 */
/*
 * todo : Remove this class
 * */
export default {
	loaderRenderer: (function () {
		const _includeBar = true;
		const _startSize = 0.02;
		const _latencyThreshold = 100;
		const _selector = 'platform-loading-bar';

		let _incTimeout: any,
			_started = false,
			_status = 0;

		let _total = 0;
		let _completed = 0;

		let _loadingBarContainer: any = null;

		let _options: any = null;
		let _completeTimeout: any = null;

		function _start() {
			if (_started) return;
			_started = true;

			_status /= 2;

			_loadingBarContainer = document.getElementById(_options.selector);

			if (!_loadingBarContainer) {
				setTimeout(() => {
					_started = false;
				}, 100);
				return;
				// this.start();
			} else {
				if (_completeTimeout) window.clearInterval(_completeTimeout);

				_set(_options.startSize);
				_loadingBarContainer.style.display = 'block';
			}
		}
		function _init(options: any) {
			_options = options || {};
			if (!_options.selector) _options.selector = _selector;
			if (!_options.startSize) _options.startSize = _startSize;
			if (!_options.latencyThreshold) _options.latencyThreshold = _latencyThreshold;
		}
		_init(null);

		function _set(n: any) {
			if (!_started) return;

			// var offset = _completed / _total;
			// _status = (offset + (n / _total));  // not working when _total > 1

			_status = n;

			const newPct = _status * 100;
			const pct = newPct + '%';
			if (_loadingBarContainer) {
				_loadingBarContainer.style.width = pct;
			}

			if (_incTimeout) window.clearInterval(_incTimeout);
			_incTimeout = window.setInterval(function () {
				_inc();
			}, 500);
		}

		function _inc() {
			if (_status >= 1) {
				return;
			}

			let rnd = 0;

			const stat = _status;
			if (stat >= 0 && stat < 0.25) {
				rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
			} else if (stat >= 0.25 && stat < 0.65) {
				rnd = (Math.random() * 3) / 100;
			} else if (stat >= 0.65 && stat < 0.9) {
				rnd = (Math.random() * 2) / 100;
			} else if (stat >= 0.9 && stat < 0.99) {
				rnd = 0.005;
			} else {
				rnd = 0;
			}

			const pct = _status + rnd;
			_set(pct);
		}

		function _complete() {
			_set(1);

			_total = 0;
			_completed = 0;
			_started = false;
			_completeTimeout = window.setTimeout(function () {
				if (_loadingBarContainer) {
					_loadingBarContainer.style.display = 'none';
				}
			}, 500);
		}

		return {
			start: _start,
			set: _set,
			status: _status,
			inc: _inc,
			complete: _complete,
		};
	})(),
};
